if (/ROARDRIVE-App/.test(navigator.userAgent)) document.documentElement.classList.add('in-app');
import { render } from 'preact';
import { App } from './ui/App';
import { isCarBrowser, hasTouch } from './utils/platform';
import { captureSource } from './utils/source';
import './styles/fonts.css';
import './styles/base.css';

// before the router rewrites the URL: whoever sent this visitor is in the query and the referrer
captureSource();

if (isCarBrowser()) document.documentElement.classList.add('is-car');
if (hasTouch()) document.documentElement.classList.add('has-touch');

render(<App />, document.getElementById('app')!);

// Cache samples/fonts for flaky in-car connectivity (production builds only).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  // Marc ("update app!!"): the app / Tesla browser must pick a new build up by itself — check for a new
  // service worker on load, every minute and whenever the page comes back to the foreground, and once the
  // new one takes over reload the shell (immediately in the garage; deferred until you leave the HUD so a
  // running engine is never cut mid-drive)
  const inHud = () => location.pathname.startsWith('/car/');
  let pendingReload = false;
  const reloadWhenSafe = () => { if (inHud()) { pendingReload = true; return; } location.reload(); };
  window.addEventListener('popstate', () => { if (pendingReload && !inHud()) location.reload(); });
  let hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener('controllerchange', () => { if (hadController) reloadWhenSafe(); hadController = true; });
  // A registration that fails (the LTE dropped while the worker fetched sw.js or installed its shell)
  // used to be the end of it until the next reload: no worker, no offline, no cached audio for the
  // whole drive. It is asked for again, half a minute later, a few times.
  const register = (attempt = 0) => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      const check = () => { void reg.update().catch(() => undefined); };
      setInterval(check, 60_000);
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
    }).catch(() => { if (attempt < 10) setTimeout(() => register(attempt + 1), 30_000); });
  };
  window.addEventListener('load', () => register());
}
